/* eslint-disable */
import createIcon from '../createIcon';

const IconLeftOutlined = createIcon({
  name: 'icon-left-outlined',
  content: '<path d="M273.49 502.46l318.013 311.652 44.522-44.522-267.13-267.13 267.13-273.491-44.522-44.522z"/>',
  width: 1024,
  height: 1024
});
export default IconLeftOutlined;
